import { render } from "./AudioSeriesCard.vue?vue&type=template&id=0651a70d&scoped=true"
import script from "./AudioSeriesCard.vue?vue&type=script&lang=js"
export * from "./AudioSeriesCard.vue?vue&type=script&lang=js"

import "./AudioSeriesCard.vue?vue&type=style&index=0&id=0651a70d&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0651a70d"]])

export default __exports__